import React from 'react';
import './Message.css';

const tryParseJSON = (jsonString) => {
  try {
    const o = JSON.parse(jsonString);
    if (o && typeof o === 'object') {
      return o;
    }
  } catch (e) { }
  return false;
};

const Message = ({ parts, sender }) => {
  const messageClass = sender === 'user' ? 'user-message' : 'bot-message';
  return (
    <div className={`Message ${messageClass}`}>
      {parts.map((part, index) => {
        if (part.type === 'image') {
          return <img key={index} src={part.data} alt="user content" className="MessageImage" />;
        }

        if (part.type === 'file') {
          return (
            <div key={index} className="FileDownload">
              <a href={part.data} target="_blank" rel="noopener noreferrer" className="DownloadLink">
                📄 Download {part.filename || 'File'}
              </a>
            </div>
          );
        }

        const jsonContent = tryParseJSON(part.data);
        if (jsonContent) {
          return (
            <div key={index} className="markdown-content">
              <pre>
                <code>{JSON.stringify(jsonContent, null, 2)}</code>
              </pre>
            </div>
          );
        }

        return <p key={index}>{part.data}</p>;
      })}
    </div>
  );
};

export default Message;
